import { Button, Card, Divider, Form, message, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import BreadCrumb from '../../../components/common/breadCrumb/BreadCrumb';
import { useImportAitPdfMutation } from '../api/endpoints/airticketInvoiceEndpoints';
import AirticketHeaderPDF from '../Components/AirticketHeaderPDF';

type Props = {};

const InvoiceAITByPDF = (props: Props) => {
  const [form] = useForm();
  const navigate = useNavigate();

  const [postPNRinvoice, { isLoading, isSuccess }] = useImportAitPdfMutation();
  const handleSubmit = async (values: any) => {
    const { file, invoice_combclient_id, invoice_sales_man_id, invoice_no } = values;
    try {
      // Create FormData object
      const formData = new FormData();

      if (file && file[0]) {
        formData.append('file', file[0].originFileObj);
      }
      if (invoice_combclient_id) {
        formData.append('invoice_combclient_id', invoice_combclient_id);
      }
      if (invoice_sales_man_id) {
        formData.append('invoice_sales_man_id', invoice_sales_man_id);
      }
      // if (invoice_no) {
      //   formData.append('invoice_no', invoice_no);
      // }

      console.log('📤 Submitting FormData...');

      await postPNRinvoice(formData);
      console.table(Object.fromEntries(formData));
    } catch (err: any) {
      console.error('❌ API Error:', err);
      message.error(err?.data?.message || 'Failed to create invoice');
    }
  };

  useEffect(() => {
    if (isSuccess) {
      message.success('Invoice Created Successfully');
      navigate(`/airticket`, {
        state: location.pathname,
      });
    }
  }, [isSuccess]);
  return (
    <>
      <BreadCrumb arrOfOption={['Invoice (PDF)']} />
      <div className='border' style={{ padding: 10, minHeight: '100vh', paddingTop: 30 }}>
        <Row justify={'center'}>
          <Card style={{ maxWidth: 500, flexGrow: 1 }} bordered={false}>
            <Divider>CREATE INVOICE BY PDF (Emirates Airlines)</Divider>
            <Form
              disabled={isLoading}
              form={form}
              layout='vertical'
              onFinish={handleSubmit}
              onFinishFailed={(value) => {
                message.error(`Enter all required (${value.errorFields.length}) Fields`);
              }}
            >
              <AirticketHeaderPDF form={form} />

              <Row justify={'end'}>
                <Form.Item>
                  <Button loading={isLoading} type='primary' htmlType='submit'>
                    Create Invoice
                  </Button>
                </Form.Item>
              </Row>
            </Form>
          </Card>
        </Row>
      </div>
    </>
  );
};

export default InvoiceAITByPDF;
